export default __webpack_public_path__ + "static/media/shark.3c14bf3b.png";